import Swiper from 'swiper';

import {Navigation} from 'swiper/modules';
export default class Governance{
    
    constructor(element) {
        this._wrapper = element;
        this._swiper = this._wrapper.querySelector('.swiper');
        this._left = this._wrapper.querySelector('.js-governance-left');
        this._right = this._wrapper.querySelector('.js-governance-right');
        
        this.init();
    }
    
    init(){
        this.swiper = new Swiper(this._swiper, {
            slidesPerView: "auto",
            modules: [Navigation],
            navigation: {
                nextEl: this._right,
                prevEl: this._left,
            },
        });
    }
    
}